// eslint-disable-next-line no-void
void import('./app/bootstrap');
